import { render, staticRenderFns } from "./PersonBirthDetails.vue?vue&type=template&id=20dca64d&"
import script from "./PersonBirthDetails.vue?vue&type=script&lang=js&"
export * from "./PersonBirthDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports